





































import Vue from "vue";
import VueSelect from "vue-select";
import Error from "@/components/basic/Error.vue";
import { mapState } from "vuex";

export default Vue.extend({
  name: "TheCountrySelect",
  props: {
    name: String,
    countryList: Array,
    placeholder: String,
    label: String,
    inputId: {
      type: String,
      default: "countrySelect",
    },
    defaultValue: {
      type: String,
      default: "",
    },
    countryDisable: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    VueSelect,
    Error,
  },
  data() {
    return {
      selectedCountry: "",
      // Used to change the dropdown open indicator https://vue-select.org/guide/components.html#openindicator
      OpenIndicator: {
        render: (createElement: CallableFunction) =>
          createElement("span", {
            class: { "custom-select__input-arrow": true },
          }),
      },
      isLabelVisible: false,
      TRANSLATION_KEY: "basic.fields.TheCountrySelect",
      loaded: false,
    };
  },
  mounted() {
    if (this.defaultValue == "" && this.name == "country") {
      let select = <HTMLInputElement>document.getElementById(this.inputId);
      if (select) {
        this.getPrimaryInputValue();
      }
    }
  },
  computed: {
    ...mapState({
      isValidFieldsChanged(): boolean {
        return this.$store.state.isValidFieldsChanged;
      },
    }),
    isValid(): boolean {
      return this.selectedCountry !== "" && this.selectedCountry !== null;
    },
    setSelectedCountry(): any {
      if (this.selectedCountry === "" && this.defaultValue !== "") {
        this.selectedCountry = this.defaultValue;
      }

      this.passSelectedValue();
      return this.selectedCountry;
    },
  },
  watch: {
    isValidFieldsChanged(): void {
      let select = <HTMLInputElement>document.getElementById(this.inputId);
      let selectValue = select.value;
      if (this.selectedCountry != selectValue && selectValue !== "") {
        this.selectedCountry = selectValue;
        this.$forceUpdate();
      }
    },
  },
  methods: {
    toggleLabelVisibility(): boolean {
      return (this.isLabelVisible = !this.isLabelVisible);
    },
    passSelectedValue(): void {
      this.$emit("selected-country", this.selectedCountry);
    },
    async getPrimaryInputValue() {
      setTimeout(() => {
        let select = <HTMLInputElement>document.getElementById("countrySelect");
        let selectValue = select.value;
        if (selectValue !== "") {
          this.selectedCountry = selectValue;
        }
      }, 4000);
      this.loaded = true;
    },
    filterInput(e: any) {
      if (!/^[\p{L}]+$/u.test(e.key)) {
          e.preventDefault();  
      }
    }
  }
});
